function handleDeliveryToggleSwitch(container, switchTo)
{
    var autoshipView  = container.querySelector(".delivery-toggle-autoship");
    var onetimeView   = container.querySelector(".delivery-toggle-onetime");
    var hiddenInput   = container.querySelector(".delivery-schedule-input");
    var redesignedCart = null;

    if ( autoshipView && onetimeView )
    {
        if ( switchTo == "autoship" )
        {
            autoshipView.classList.add("active");
            onetimeView.classList.remove("active");
            if ( hiddenInput )
            {
                hiddenInput.value = "autoship";
            }
        }
        else
        {
            autoshipView.classList.remove("active");
            onetimeView.classList.add("active");
            if ( hiddenInput )
            {
                hiddenInput.value = "onetime";
            }
        }
        redesignedCart = document.querySelector(".welleasy-redesigned-cart");
        if ( redesignedCart )
        {
            updateAllItemsDeliverySchedule( redesignedCart, switchTo );
        }
    }
}

function handleDeliveryRadioChange(redesignedCart, radio)
{
    var deliveryType = radio.value;
    updateDeliverySavingsMessage(redesignedCart, deliveryType);
    updateAllItemsDeliverySchedule(redesignedCart, deliveryType);
}


function handleDeliverySwitchClick(e)
{
    var switchBtn;
    var switchTo;
    var container;

    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();
    
    switchBtn  = e.currentTarget;
    switchTo   = switchBtn.getAttribute("data-switch-to");
    container  = switchBtn.closest(".delivery-schedule-section");
    if (container && switchTo)
    {
        // Force all products to match the selected state - take priority
        handleDeliveryToggleSwitch(container, switchTo);
    }
    
    return false;
}

function initRedesignedCart()
{
    var redesignedCart   = document.querySelector(".welleasy-redesigned-cart");
    var deliverySwitches = null;
    var deliveryRadios   = null;
    var i;
    var j;
    var switchBtn;
    var radio;

    if ( redesignedCart )
    {
        deliverySwitches = redesignedCart.querySelectorAll(".js-delivery-switch");
        for ( i = 0; i < deliverySwitches.length; i++ )
        {
            switchBtn = deliverySwitches[i];
            switchBtn.addEventListener("click", handleDeliverySwitchClick);
        }
        deliveryRadios = redesignedCart.querySelectorAll(".delivery-radio");
        for ( j = 0; j < deliveryRadios.length; j++ )
        {
            radio = deliveryRadios[j];
            radio.addEventListener("change", function onDeliveryRadioChange()
            {
                handleDeliveryRadioChange(redesignedCart, radio);
            });
        }
        updateDeliveryOptionState(redesignedCart);
        setProgressBarWidth(redesignedCart);
    }
}

function isValidAutoshipToggle(toggle)
{
    const hasValue      = toggle.value && toggle.value.trim() != "";
    const hasAction     = toggle.getAttribute("data-action");
    const isSellingPlan = toggle.getAttribute("title") == "selling_plan" ||
                        (hasAction && hasAction.includes("selling_plan")) ||
                        toggle.name == "cart-item-selling-plan";

    return hasValue && hasAction && isSellingPlan;
}

function addToggleIfValid(allToggles, toggle)
{
    if (isValidAutoshipToggle(toggle) && allToggles.indexOf(toggle) == -1)
    {
        allToggles.push(toggle);
    }
}

function collectTogglesForSelector(allToggles, selector)
{
    const found = document.querySelectorAll(selector);
    found.forEach(function addToggle(toggle)
    {
        addToggleIfValid(allToggles, toggle);
    });
}

function findAllAutoshipToggles()
{
    const selectors = [
        "input[data-ajax-cart-request-button-new][title='selling_plan']",
        "input[name='cart-item-selling-plan'][data-ajax-cart-request-button-new]",
        "input[data-ajax-cart-request-button-new]"
    ];

    const allToggles = [];

    selectors.forEach(function processSelector(selector)
    {
        collectTogglesForSelector(allToggles, selector);
    });

    return allToggles;
}

// function mergeSecondPassToggles(allToggles)
// {
//     const secondPassToggles = findAllAutoshipToggles();

//     secondPassToggles.forEach(function mergeToggle(toggle)
//     {
//         if (allToggles.indexOf(toggle) == -1)
//         {
//             allToggles.push(toggle);
//         }
//     });
// }

// function processSecondPass(allToggles, deliveryType, container)
// {
//     mergeSecondPassToggles(allToggles);
//     processToggles(allToggles, deliveryType, container);
// }

// function scheduleProcessSecondPass(allToggles, deliveryType, container)
// {
//     setTimeout(function onProcessSecondPass()
//     {
//         processSecondPass(allToggles, deliveryType, container);
//     }, 150);
// }

function setUpRedesignedCartAutoshipSwitches()
{
    // Disabled for now - let default handlers work
}

async function removeLines( variantId )
{
    const updates = {};

    variantId.forEach(function setUpdateKey(key)
    {
        updates[key] = 0;
    });

    await fetch( '/cart/update.js',
    {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ updates })
    });
}

async function addLines( items )
{
    await fetch( '/cart/add.js',
    {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: items, sections: "cart-drawer-section,cart-products-auto-render,welleasy-new-cart-template" })
    }).then(function parseAddLinesResponse(response) { return response.json(); }).then(function updateDrawerFromAddLines(cart) { updateCartDrawer(cart); });
}

async function swapSellingPlans( batch ) {
    const cart = await fetch( '/cart.js' ).then(function parseCartJson(r) { return r.json(); });

    const toRemove = [ ];
    const toAdd = [ ];

    batch.forEach(function processSwapItem(batchItem)
    {
        var line;
        line = cart.items.find(function matchVariantId(item) { return item.id == batchItem.variantId; });
        if (line)
        {
            toRemove.push(line.key);
            toAdd.push(
            {
                id: line.variant_id,
                quantity: line.quantity,
                selling_plan: (batchItem.sellingPlanId == "") ? null : batchItem.sellingPlanId,
                properties: line.properties
            });
        }
    });

    if ( toRemove.length && toAdd.length )
    {
        await removeLines(toRemove);
        await addLines(toAdd);
    }
}

function updateAllItemsDeliverySchedule(container, deliveryType)
{
    var allSwitches;
    var switchArray;
    var i;
    var switchEl;
    var $switch;
    var currentChecked;
    var shouldBeChecked;
    var switchesToUpdate;
    var updates;
    var variantId;
    var sellingPlanId;

    allSwitches = container.querySelectorAll("input[data-ajax-cart-request-button-new][title='selling_plan']");
    if ( allSwitches && allSwitches.length != 0 )
    {
        switchArray    = Array.from(allSwitches);
        shouldBeChecked = (deliveryType == "autoship");
        switchesToUpdate = [];
        for ( i = 0; i < switchArray.length; i++ )
        {
            switchEl = switchArray[i];
            $switch = $(switchEl);
            currentChecked = $switch.prop("checked");
            if ( currentChecked != shouldBeChecked )
            {
                switchesToUpdate.push(switchEl);
            }
        }
        updates = [];
        for ( i = 0; i < switchesToUpdate.length; i++ )
        {
            variantId = switchesToUpdate[i].dataset.variant;
            sellingPlanId = switchesToUpdate[i].dataset.sellingPlanId;
            updates.push( { "variantId": variantId, "sellingPlanId": sellingPlanId } );
        }
        swapSellingPlans( updates );
    }
}

function triggerToggleClick(toggle)
{
    if (!toggle.checked)
    {
        toggle.checked = true;
    }
    toggle.click();
}

function triggerDisableToggleClick(toggle)
{
    if (toggle.checked)
    {
        toggle.checked = false;
    }
    toggle.click();
}

function scheduleTriggerToggleClick(toggle, index)
{
    setTimeout(function onTriggerToggleClick()
    {
        triggerToggleClick(toggle);
    }, index * 250);
}

function enableAutoshipToggle(toggle, index, clickedCount)
{
    var wasChecked = toggle.checked;

    if (!wasChecked)
    {
        clickedCount.value++;

        var currentAction = toggle.getAttribute("data-action") || "";
        var sellingPlanId = toggle.value;

        if (sellingPlanId && currentAction && !currentAction.includes("selling_plan=" + sellingPlanId))
        {
            var urlMatch = currentAction.match(/line=(\d+)&quantity=(\d+)/);
            if (urlMatch)
            {
                var line     = urlMatch[1];
                var quantity = urlMatch[2];
                toggle.setAttribute("data-action", "/cart/change?line=" + line + "&quantity=" + quantity + "&selling_plan=" + sellingPlanId);
            }
        }

        toggle.checked = true;

        scheduleTriggerToggleClick(toggle, index);
    }
}

function scheduleTriggerDisableToggleClick(toggle, index)
{
    setTimeout(function onTriggerDisableToggleClick()
    {
        triggerDisableToggleClick(toggle);
    }, index * 250);
}

function disableAutoshipToggle(toggle, index, clickedCount)
{
    var wasChecked = toggle.checked;

    if (wasChecked)
    {
        clickedCount.value++;

        var currentAction = toggle.getAttribute("data-action") || "";

        if (currentAction && currentAction.includes("selling_plan="))
        {
            var urlMatch = currentAction.match(/line=(\d+)&quantity=(\d+)/);
            if (urlMatch)
            {
                var line     = urlMatch[1];
                var quantity = urlMatch[2];
                toggle.setAttribute("data-action", "/cart/change?line=" + line + "&quantity=" + quantity + "&selling_plan=");
            }
        }

        toggle.checked = false;

        scheduleTriggerDisableToggleClick(toggle, index);
    }
}

function processToggles(allToggles, deliveryType, container)
{
    var clickedCount = { value: 0 };

    if (deliveryType == "autoship")
    {
        allToggles.forEach(function enableToggle(toggle, index)
        {
            enableAutoshipToggle(toggle, index, clickedCount);
        });
    }
    else if (deliveryType == "onetime")
    {
        allToggles.forEach(function disableToggle(toggle, index)
        {
            disableAutoshipToggle(toggle, index, clickedCount);
        });
    }

    setTimeout(function onUpdateDeliveryOptionState()
    {
        updateDeliveryOptionState(container);
    }, (allToggles.length * 250) + 500);
}

function updateDeliverySavingsMessage(container, deliveryType)
{
    var savingsHeader   = container.querySelector(".delivery-savings-header");
    var existingStrong  = null;
    var savingsFormatted = "£0.00";
    var savingsAmount   = null;
    var pounds          = 0;

    if ( savingsHeader )
    {
        existingStrong = savingsHeader.querySelector("strong");
        if ( existingStrong )
        {
            savingsFormatted = existingStrong.textContent.trim();
        }
        else
        {
            savingsAmount   = savingsHeader.getAttribute("data-savings-amount") || "0";
            pounds          = parseFloat(savingsAmount) / 100;
            savingsFormatted = "£" + pounds.toFixed(2);
        }
        if ( deliveryType == "autoship" )
        {
            savingsHeader.innerHTML = "You're saving <strong>" + savingsFormatted + "</strong> with Autoship – delivered every 4 weeks, so you never run out";
        }
        else
        {
            savingsHeader.innerHTML = "Switch to Autoship and save 5% more – delivered every 4 weeks so you never run out";
        }
    }
}

function updateDeliveryOption(option, hasAutoship)
{
    const radio = option.querySelector(".delivery-radio");

    if (hasAutoship && option.dataset.deliveryType == "autoship")
    {
        option.classList.add("selected");
        if (radio)
        {
            radio.checked = true;
        }
    }
    else if (!hasAutoship && option.dataset.deliveryType == "onetime")
    {
        option.classList.add("selected");
        if (radio)
        {
            radio.checked = true;
        }
    }
    else
    {
        option.classList.remove("selected");
    }
}

function setProgressBarWidth(container)
{
    const progressBar = container.querySelector(".cart-delivery-progress-bar[data-progress-width]");
    if (progressBar)
    {
        const progressWidth = progressBar.getAttribute("data-progress-width");
        if (progressWidth)
        {
            progressBar.style.setProperty("--progress-width", progressWidth);
        }
    }
}

function updateDeliveryOptionState(container)
{
    const autoshipToggles = container.querySelectorAll("input[data-ajax-cart-request-button-new][title='selling_plan']");
    const hasAutoship     = Array.from(autoshipToggles).some(function checkChecked(toggle)
    {
        return toggle.checked;
    });

    const deliveryOptions = container.querySelectorAll(".delivery-option");
    deliveryOptions.forEach(function updateOption(option)
    {
        updateDeliveryOption(option, hasAutoship);
    });

    const deliveryType = hasAutoship ? "autoship" : "onetime";
    updateDeliverySavingsMessage(container, deliveryType);
}

function setUpRedesignedCartQuantityHandlers()
{
    // Disabled - using base cart quantity selectors
    // Base cart handles quantity selectors via setUpCartEventsWellEasy()
}

function handleCartStateUpdate(state, prevState)
{
    setTimeout(function onCartStateUpdateDelayed()
    {
        initRedesignedCart();
        if (state && state.cart)
        {
            updateRedesignedCartContent(state.cart);
        }
        // Base cart handles quantity selectors via setUpCartEventsWellEasy()
    }, 100);
}

function handleCartRequestEnd()
{
    setTimeout(function onCartRequestEndDelayed()
    {
        // Clear all processing flags and re-enable buttons
        var redesignedCart = document.querySelector(".welleasy-redesigned-cart");
        if (redesignedCart)
        {
            var $allButtons = $(redesignedCart).find('.cart-quantity-value-change');
            
            // Clear all safety timeouts
            $allButtons.each( function clearCartButtonSafetyTimeout( )
            {
                var $btn    = $( this );
                var timeout = $btn.data( "safetyTimeout" );
                if ( timeout )
                {
                    clearTimeout( timeout );
                    $btn.removeData( "safetyTimeout" );
                }
            } );
            
            // Clear processing flags and re-enable buttons
            $allButtons.data('processing', false);
            $allButtons.removeClass('disabled').css('pointer-events', '');
            
            // Check each plus button against inventory limits
            $allButtons.filter( "[data-type=\"plus\"]" ).each( function checkPlusButtonInventory( )
            {
                var $plusButton = $( this );
                var $qtyInput = $plusButton.closest('.cart-quantity').find('input.cart-quantity-value');
                
                if ($qtyInput.length)
                {
                    var currentQty = parseInt($qtyInput.val(), 10) || 0;
                    var maxQty = $qtyInput.attr('data-max');
                    
                    if (maxQty)
                    {
                        var maxQuantity = parseInt(maxQty, 10);
                        if (!isNaN(maxQuantity) && currentQty >= maxQuantity)
                        {
                            // At max inventory - keep unchangeable class
                            $plusButton.addClass('cart-quantity-value-unchangeable');
                        }
                        else
                        {
                            // Can increase - remove unchangeable class
                            $plusButton.removeClass('cart-quantity-value-unchangeable');
                        }
                    }
                    else
                    {
                        // No max limit - can always increase
                        $plusButton.removeClass('cart-quantity-value-unchangeable');
                    }
                }
            });
        }
        
        initRedesignedCart();
        var cartState = getCartState();
        if (cartState && cartState.cart)
        {
            updateRedesignedCartContent(cartState.cart);
        }
        // Base cart handles quantity selectors via setUpCartEventsWellEasy()
    }, 100);
}

function handleMutationForReinit(mutations)
{
    var shouldReinit = false;
    mutations.forEach(function checkMutation(mutation)
    {
        if (mutation.type == "childList" && mutation.addedNodes.length > 0)
        {
            shouldReinit = true;
        }
    });
    if (shouldReinit)
    {
        setTimeout(function onReinitDelayed()
        {
            initRedesignedCart();
        }, 50);
    }
}

function addItemToTotalRrp(totalRrp, item)
{
    if (item.variant && item.variant.compare_at_price)
    {
        return totalRrp + (item.variant.compare_at_price * item.quantity);
    }
    if (item.compare_at_price)
    {
        return totalRrp + (item.compare_at_price * item.quantity);
    }
    return totalRrp;
}

function addItemToTotalSavings(totalSavings, item)
{
    var comparePrice = 0;
    if (item.variant && item.variant.compare_at_price)
    {
        comparePrice = item.variant.compare_at_price * item.quantity;
    }
    else if (item.compare_at_price)
    {
        comparePrice = item.compare_at_price * item.quantity;
    }
    if (comparePrice > item.final_line_price)
    {
        return totalSavings + (comparePrice - item.final_line_price);
    }
    return totalSavings;
}

function updateCartItemInRedesignedCart(item)
{
    var cartItem         = document.querySelector(".welleasy-redesigned-cart .we_cart_item[data-variant-id='" + item.variant_id + "']");
    var qtyInput         = null;
    var minusButton      = null;
    var plusButton       = null;
    var lineNumber       = null;
    var newMinusQuantity = 0;
    var newMinusHref     = "";
    var newPlusHref      = "";
    var maxQuantity      = null;
    var canIncrease      = true;
    var maxQty           = 0;
    var priceEl          = null;
    var comparePrice     = 0;
    var wasPriceEl       = null;
    var reductionEl      = null;
    var diff             = 0;
    var diffPC           = 0;

    if ( !cartItem )
    {
        cartItem = document.querySelector(".welleasy-redesigned-cart .products-in-cart[data-variant-id='" + item.variant_id + "']");
    }
    if ( cartItem )
    {
        qtyInput = cartItem.querySelector(".cart-quantity-value");
        if ( qtyInput )
        {
            qtyInput.value = item.quantity;
            qtyInput.setAttribute("data-initial-value", item.quantity);
            if ( item.variant && item.variant.inventory_management == "shopify" && item.variant.inventory_policy == "deny" && item.variant.inventory_quantity )
            {
                qtyInput.setAttribute("data-max", item.variant.inventory_quantity);
            }
            else
            {
                qtyInput.removeAttribute("data-max");
            }
        }
        minusButton = cartItem.querySelector(".cart-quantity-value-change[data-type='minus']");
        plusButton = cartItem.querySelector(".cart-quantity-value-change[data-type='plus']");
        lineNumber = qtyInput ? (qtyInput.getAttribute("data-line") || qtyInput.getAttribute("data-ajax-cart-quantity-input")) : null;
        if ( lineNumber )
        {
            if ( minusButton )
            {
                newMinusQuantity = Math.max(1, item.quantity - 1);
                newMinusHref = "/cart/change?line=" + lineNumber + "&quantity=" + newMinusQuantity;
                minusButton.setAttribute("href", newMinusHref);
            }
            if ( plusButton )
            {
                newPlusHref = "/cart/change?line=" + lineNumber + "&quantity=" + (item.quantity + 1);
                plusButton.setAttribute("href", newPlusHref);
            }
            if ( minusButton )
            {
                $(minusButton).data("processing", false);
                minusButton.classList.remove("disabled");
                minusButton.style.pointerEvents = "";
            }
            if ( plusButton )
            {
                maxQuantity = qtyInput ? (qtyInput.getAttribute("data-max") || null) : null;
                canIncrease = true;
                if ( maxQuantity )
                {
                    maxQty = parseInt(maxQuantity, 10);
                    canIncrease = (isNaN(maxQty) || item.quantity < maxQty);
                }
                $(plusButton).data("processing", false);
                plusButton.classList.remove("disabled");
                plusButton.style.pointerEvents = "";
                if ( canIncrease )
                {
                    plusButton.classList.remove("cart-quantity-value-unchangeable");
                }
                else
                {
                    plusButton.classList.add("cart-quantity-value-unchangeable");
                }
            }
        }
        cartItem.setAttribute("data-cart-item-quantity", item.quantity);
        cartItem.setAttribute("data-cart-item-price", item.final_price);
        priceEl = cartItem.querySelector(".cart-price .item-final-price");
        if ( priceEl )
        {
            priceEl.innerHTML = Shopify.formatMoney(item.final_line_price);
        }
        comparePrice = 0;
        if ( item.variant && item.variant.compare_at_price )
        {
            comparePrice = item.variant.compare_at_price * item.quantity;
        }
        else if ( item.compare_at_price )
        {
            comparePrice = item.compare_at_price * item.quantity;
        }
        wasPriceEl  = cartItem.querySelector(".cart-price .item-was-price");
        reductionEl = cartItem.querySelector(".cart-price .item-reduction");
        if ( comparePrice > item.final_line_price )
        {
            diff   = comparePrice - item.final_line_price;
            diffPC = Math.round((diff * 100) / comparePrice);
            if ( wasPriceEl )
            {
                wasPriceEl.innerHTML = Shopify.formatMoney(comparePrice) + " ";
                wasPriceEl.parentElement.style.visibility = "";
            }
            if ( reductionEl )
            {
                reductionEl.innerHTML = "-" + diffPC + "%";
            }
        }
        else if ( wasPriceEl )
        {
            wasPriceEl.parentElement.style.visibility = "hidden";
        }
    }
}

function isVariantInCart(items, variantId)
{
    return items.some(function itemMatchesVariant(item)
    {
        return item.variant_id == variantId;
    });
}

function removeCartItemIfNotInCart(cartItemEl, items)
{
    var variantId   = cartItemEl.getAttribute("data-variant-id");
    var stillInCart = isVariantInCart(items, variantId);

    if (!stillInCart)
    {
        var nextEl = cartItemEl.nextElementSibling;
        if (nextEl && nextEl.tagName == "HR")
        {
            nextEl.remove();
        }
        cartItemEl.remove();
    }
}

function addItemToAutoshipSavings(autoshipSavings, item)
{
    var sellingPlan;
    var adjustment;
    var discountMultiplier;
    var memberPrice;
    var itemSavings;
    var result;
    var skip;
    var themeSettings;

    result = autoshipSavings;
    skip   = (item.product_type && item.product_type.toLowerCase().includes("membership"));
    themeSettings = (window.theme && window.theme.settings) || {};
    if (themeSettings.annual_subscription_product) { skip = skip || (item.product_id == themeSettings.annual_subscription_product.id); }
    if (themeSettings.monthly_subscription_product) { skip = skip || (item.product_id == themeSettings.monthly_subscription_product.id); }
    if (themeSettings.legacy_annual_subscription_product) { skip = skip || (item.product_id == themeSettings.legacy_annual_subscription_product.id); }

    if (!skip)
    {
        sellingPlan = null;
        if (item.selling_plan_allocation && item.selling_plan_allocation.selling_plan)
        {
            sellingPlan = item.selling_plan_allocation.selling_plan;
        }

        if (sellingPlan && sellingPlan.price_adjustments && sellingPlan.price_adjustments.length > 0)
        {
            adjustment  = sellingPlan.price_adjustments[0];
            memberPrice = item.final_line_price;

            if (adjustment.value_type == "percentage" && adjustment.value > 0)
            {
                discountMultiplier = 100 - adjustment.value;
                itemSavings        = (item.final_line_price * 100 / discountMultiplier) - item.final_line_price;
                result             = autoshipSavings + itemSavings;
            }
            else if (adjustment.value_type == "fixed_amount" && adjustment.value > 0)
            {
                result = autoshipSavings + (adjustment.value * item.quantity);
            }
        }
    }
    return result;
}

function getItemComparePrice(item)
{
    var comparePrice = 0;
    if (item.variant && item.variant.compare_at_price)
    {
        comparePrice = item.variant.compare_at_price * item.quantity;
    }
    else if (item.compare_at_price)
    {
        comparePrice = item.compare_at_price * item.quantity;
    }
    return comparePrice;
}

function addItemToMemberSavings(memberSavings, item)
{
    var comparePrice;
    var memberPrice;
    var priceAdjustments;
    var adjustment;
    var discountMultiplier;
    var result;
    var skip;
    var themeSettings;

    result = memberSavings;
    skip   = (item.product_type && item.product_type.toLowerCase().includes("membership"));
    themeSettings = (window.theme && window.theme.settings) || {};
    if (themeSettings.annual_subscription_product) { skip = skip || (item.product_id == themeSettings.annual_subscription_product.id); }
    if (themeSettings.monthly_subscription_product) { skip = skip || (item.product_id == themeSettings.monthly_subscription_product.id); }
    if (themeSettings.legacy_annual_subscription_product) { skip = skip || (item.product_id == themeSettings.legacy_annual_subscription_product.id); }

    if (!skip)
    {
        comparePrice = getItemComparePrice(item);
        if (comparePrice > 0)
        {
            memberPrice = item.final_line_price;
            if (item.selling_plan_allocation)
            {
                priceAdjustments = item.selling_plan_allocation.selling_plan.price_adjustments;
                if (priceAdjustments && priceAdjustments.length > 0)
                {
                    adjustment = priceAdjustments[0];
                    if (adjustment.value_type == "percentage" && adjustment.value > 0)
                    {
                        discountMultiplier = 100 - adjustment.value;
                        if (discountMultiplier > 0)
                        {
                            memberPrice = Math.round((item.final_line_price * 100) / discountMultiplier);
                        }
                    }
                    else if (adjustment.value_type == "fixed_amount" && adjustment.value > 0)
                    {
                        memberPrice = item.final_line_price + (adjustment.value * item.quantity);
                    }
                }
            }
            if (comparePrice > memberPrice)
            {
                result = memberSavings + (comparePrice - memberPrice);
            }
        }
    }
    return result;
}

function updateRedesignedCartContent(cart)
{
    // Normalize cart object - handle different structures
    var cartData = cart.cart || cart;
    
    var autoshipSavingsCalculated  = 0;
    var totalRrpForCorrection       = 0;
    var totalSubtotalForCorrection  = cartData.items_subtotal_price || 0;
    
    if (cartData.items && cartData.items.length > 0)
    {
        var i;
        var item;
        for (i = 0; i < cartData.items.length; i++)
        {
            item = cartData.items[i];
            autoshipSavingsCalculated = addItemToAutoshipSavings(autoshipSavingsCalculated, item);
            totalRrpForCorrection = totalRrpForCorrection + getItemComparePrice(item);
        }
    }
    
    var roundedAutoshipSavings  = Math.round(autoshipSavingsCalculated);
    var formattedAutoshipSavings = Shopify.formatMoney(roundedAutoshipSavings);
    
    var cartCountEl = document.querySelector(".welleasy-redesigned-cart .cart-page-title span");
    if (cartCountEl && cartData.item_count != undefined)
    {
        cartCountEl.textContent = cartData.item_count;
    }

    var subtotalEl = document.querySelector(".welleasy-redesigned-cart .order-summary-subtotal .subtotal-amount strong");
    if (subtotalEl && cartData.items_subtotal_price != undefined)
    {
        subtotalEl.innerHTML = Shopify.formatMoney(cartData.items_subtotal_price);
    }

    var subtotalAmountEl = document.querySelector(".welleasy-redesigned-cart .order-summary-subtotal .subtotal-amount");
    var rrpEl = document.querySelector(".welleasy-redesigned-cart .order-summary-subtotal .rrp-amount");
    if (cartData.items && cartData.items.length > 0)
    {
        var totalRrp = 0;
        var i;
        var item;
        for (i = 0; i < cartData.items.length; i++)
        {
            item = cartData.items[i];
            totalRrp = addItemToTotalRrp(totalRrp, item);
        }

        if (!rrpEl && subtotalAmountEl)
        {
            rrpEl = document.createElement("span");
            rrpEl.className = "rrp-amount";
            subtotalAmountEl.appendChild(rrpEl);
        }
        
        if (rrpEl)
        {
            if (totalRrp > cartData.items_subtotal_price)
            {
                rrpEl.innerHTML     = "(RRP <span class=\"rrp-price\">" + Shopify.formatMoney(totalRrp) + "</span>)";
                rrpEl.style.display = "";
            }
            else
            {
                rrpEl.style.display = "none";
            }
        }
    }

    var itemCountEl = document.querySelector(".welleasy-redesigned-cart .order-summary-subtotal .item-count");
    if (itemCountEl && cartData.item_count != undefined)
    {
        itemCountEl.textContent = cartData.item_count + " items";
    }

    if (cartData.items && cartData.items.length > 0)
    {
        var totalSavings = 0;
        cartData.items.forEach(function sumSavingsForItem(item)
        {
            totalSavings = addItemToTotalSavings(totalSavings, item);
        });

        // cart-saving-message is hidden
        var savingsEl = document.querySelector(".welleasy-redesigned-cart .cart-saving-message");
        if (savingsEl)
        {
            savingsEl.style.display = "none";
        }
    }

    // Product items are now replaced directly from AJAX response in lightning-cart.js
    // No need to update/remove items individually here - base cart handles it
    
    setTimeout(function rebindCartEvents()
    {
        setUpCartEventsWellEasy();
        stripLiquidCartAttrFromCartPageButtons();
    }, 100);

    var progressBar  = document.querySelector(".welleasy-redesigned-cart .cart-delivery-progress-bar");
    var progressInfo = document.querySelector(".welleasy-redesigned-cart .cart-delivery-progress-info");
    if (progressBar && cartData.items_subtotal_price != undefined)
    {
        var freeDeliveryCriteria = 3900;
        var freeDeliveryDiff     = freeDeliveryCriteria - cartData.items_subtotal_price;

        if (freeDeliveryDiff <= 0)
        {
            progressBar.setAttribute("data-progress-width", "100%");
            var innerBar = progressBar.querySelector(".cart-delivery-progress-bar-inner");
            if (innerBar)
            {
                innerBar.style.width = "100%";
            }
            if (progressInfo)
            {
                progressInfo.innerHTML = "<p>You qualify for free delivery</p>";
            }
        }
        else
        {
            var progress = Math.min(100, (cartData.items_subtotal_price / freeDeliveryCriteria) * 100);
            progressBar.setAttribute("data-progress-width", progress + "%");
            var innerBar = progressBar.querySelector(".cart-delivery-progress-bar-inner");
            if (innerBar)
            {
                innerBar.style.width = progress + "%";
            }
            if (progressInfo)
            {
                progressInfo.innerHTML = "<p>Add <strong>" + Shopify.formatMoney(freeDeliveryDiff) + "</strong> for <strong>FREE shipping</strong></p>";
            }
        }
    }

    var deliveryToggleSavings = document.querySelector(".welleasy-redesigned-cart .delivery-toggle-savings strong");
    if (deliveryToggleSavings)
    {
        deliveryToggleSavings.innerHTML = formattedAutoshipSavings;
    }

    var onetimeSavingsStrongs = document.querySelectorAll(".welleasy-redesigned-cart .delivery-toggle-onetime-savings strong, .welleasy-redesigned-cart .delivery-toggle-switch-onetime-btn strong");
    var j;
    var el;
    for (j = 0; j < onetimeSavingsStrongs.length; j++)
    {
        el = onetimeSavingsStrongs[j];
        el.innerHTML = formattedAutoshipSavings;
    }

    var deliveryScheduleSection = document.querySelector(".welleasy-redesigned-cart .delivery-schedule-section");
    if (deliveryScheduleSection)
    {
        deliveryScheduleSection.setAttribute("data-savings-amount", roundedAutoshipSavings);
    }
    
    var groceryBoxPrice = document.querySelector(".welleasy-redesigned-cart .grocery-box-price");
    if (groceryBoxPrice && cartData.items_subtotal_price != undefined)
    {
        if (cartData.items_subtotal_price >= 3900)
        {
            groceryBoxPrice.textContent = "FREE";
        }
        else
        {
            var defaultPrice = groceryBoxPrice.getAttribute("data-default-price") || "£4.99";
            groceryBoxPrice.textContent = defaultPrice;
        }
    }
    
    var orderSummarySubtotal = document.querySelector(".welleasy-redesigned-cart .order-summary-subtotal");
    var savingsBreakdown      = document.querySelector(".welleasy-redesigned-cart .order-savings-breakdown");
    
    if (!savingsBreakdown && orderSummarySubtotal && cartData.items)
    {
        savingsBreakdown = document.createElement("div");
        savingsBreakdown.className = "order-savings-breakdown";
        orderSummarySubtotal.parentElement.insertBefore(savingsBreakdown, orderSummarySubtotal.nextSibling);
    }
    
    if (savingsBreakdown && cartData.items)
    {
        var totalRrp               = 0;
        var hasActiveAutoshipItems  = false;
        var k;
        var savingsItem;

        for (k = 0; k < cartData.items.length; k++)
        {
            savingsItem = cartData.items[k];
            totalRrp = totalRrp + getItemComparePrice(savingsItem);
            if (savingsItem.selling_plan_allocation)
            {
                hasActiveAutoshipItems = true;
            }
        }
        
        var cartSubtotal            = cartData.items_subtotal_price || 0;
        var cartTotalBeforeAutoship = cartSubtotal + autoshipSavingsCalculated;
        var memberSavings           = totalRrp - cartTotalBeforeAutoship;
        var roundedMemberSavings    = Math.round(memberSavings);
        
        roundedMemberSavings = roundedMemberSavings - 2;
        if (roundedMemberSavings < 0)
        {
            roundedMemberSavings = 0;
        }
        
        var memberSavingsRow = savingsBreakdown.querySelector(".member-savings-row");
        
        if (memberSavingsRow)
        {
            var memberSavingsAmount = memberSavingsRow.querySelector(".savings-amount");
            if (memberSavingsAmount)
            {
                if (roundedMemberSavings > 0)
                {
                    memberSavingsAmount.textContent = "-" + Shopify.formatMoney(roundedMemberSavings);
                    memberSavingsRow.removeAttribute("style");
                    memberSavingsRow.style.display = "";
                }
                else
                {
                    memberSavingsRow.style.display = "none";
                }
            }
        }
        else
        {
            var memberRow = document.createElement("div");
            memberRow.className = "savings-row member-savings-row";
            memberRow.innerHTML = '<span class="savings-label">Member Savings:</span><span class="savings-amount">-' + Shopify.formatMoney(roundedMemberSavings) + '</span>';
            if (memberSavings > 0)
            {
                memberRow.style.display = "";
            }
            else
            {
                memberRow.style.display = "none";
            }
            if (savingsBreakdown.firstChild)
            {
                savingsBreakdown.insertBefore(memberRow, savingsBreakdown.firstChild);
            }
            else
            {
                savingsBreakdown.appendChild(memberRow);
            }
        }
        
        var autoshipRow = savingsBreakdown.querySelector(".autoship-savings-row");
        
        if (autoshipRow)
        {
            var autoshipSavingsAmount = autoshipRow.querySelector(".savings-amount");
            if (autoshipSavingsAmount)
            {
                // Use EXACT same formatted value as top banner - no recalculation
                autoshipSavingsAmount.textContent = "-" + formattedAutoshipSavings;
                if (hasActiveAutoshipItems)
                {
                    autoshipRow.removeAttribute("style");
                    autoshipRow.style.display = "";
                }
                else
                {
                    autoshipRow.style.display = "none";
                }
            }
        }
        else
        {
            var autoshipRowNew = document.createElement("div");
            autoshipRowNew.className = "savings-row autoship-savings-row";
            autoshipRowNew.innerHTML = '<span class="savings-label">Autoship Savings:</span><span class="savings-amount">-' + formattedAutoshipSavings + '</span>';
            if (hasActiveAutoshipItems)
            {
                autoshipRowNew.style.display = "";
            }
            else
            {
                autoshipRowNew.style.display = "none";
            }
            var insertAfter = savingsBreakdown.querySelector(".member-savings-row");
            if (insertAfter)
            {
                insertAfter.parentElement.insertBefore(autoshipRowNew, insertAfter.nextSibling);
            }
            else
            {
                savingsBreakdown.appendChild(autoshipRowNew);
            }
        }
        
        var orderDiscountRow = savingsBreakdown.querySelector(".order-discount-row");
        if (cartData.cart_level_discount_applications && cartData.cart_level_discount_applications.length > 0)
        {
            var totalDiscount = 0;
            var m;
            var discount;
            for (m = 0; m < cartData.cart_level_discount_applications.length; m++)
            {
                discount = cartData.cart_level_discount_applications[m];
                totalDiscount += discount.total_allocated_amount || 0;
            }
            
            if (orderDiscountRow)
            {
                var discountAmount = orderDiscountRow.querySelector(".discount-amount");
                if (discountAmount && totalDiscount > 0)
                {
                    discountAmount.textContent = "-" + Shopify.formatMoney(Math.round(totalDiscount));
                    orderDiscountRow.style.display = "";
                }
            }
        }
        else if (orderDiscountRow)
        {
            orderDiscountRow.style.display = "none";
        }
    }

    initRedesignedCart();
    // Autoship switches disabled for now
    // setUpRedesignedCartAutoshipSwitches();
    setUpCartEventsWellEasy();
}

function moveCartSavingMessage()
{
    var savingMessage         = document.querySelector(".cart-saving-message");
    var targetContainer       = document.querySelector(".welleasy-new-cart-first");
    var existingClonedMessage = document.querySelector(".mobile-cloned-message");
    var clonedMessage         = null;

    if ( savingMessage && targetContainer )
    {
        if ( window.innerWidth <= 768 )
        {
            if ( !existingClonedMessage )
            {
                clonedMessage = savingMessage.cloneNode(true);
                clonedMessage.style.display = "block";
                clonedMessage.classList.add("mobile-cloned-message");
                targetContainer.appendChild(clonedMessage);
            }
        }
        else
        {
            if ( existingClonedMessage )
            {
                existingClonedMessage.remove();
            }
        }
    }
}

function checkQuizCartParam()
{
    var urlParams = new URLSearchParams(window.location.search);
    var quizcart  = urlParams.get("quizcart");
    var view      = urlParams.get("view");

    if (quizcart == "1" || view == "quizcart" || quizcart != null)
    {
        if (!document.querySelector(".welleasy-redesigned-cart"))
        {
            console.log("QuizCart parameter detected but standard cart shown - may need page reload");
        }
    }
}

function stripLiquidCartAttrFromCartPageButtons()
{
    var path    = ( window.location.pathname || "" ).replace( /\/$/, "" );
    var cart    = document.querySelector( ".welleasy-redesigned-cart" );
    var buttons = null;
    var i       = 0;

    if ( path == "/cart" && cart )
    {
        buttons = cart.querySelectorAll( "[data-ajax-cart-request-button].cart-quantity-value-change, [data-ajax-cart-request-button][title='Remove']" );
        for ( i = 0; i < buttons.length; i++ )
        {
            buttons[i].removeAttribute( "data-ajax-cart-request-button" );
        }
    }
}

function initRedesignedCartOnLoad()
{
    moveCartSavingMessage();
    window.addEventListener("resize", moveCartSavingMessage);
    checkQuizCartParam();

    initRedesignedCart();

    // Get initial cart state and update content
    var cartState = getCartState();
    if (cartState && cartState.cart)
    {
        updateRedesignedCartContent(cartState.cart);
    }
    
    // Base cart handles quantity selectors via setUpCartEventsWellEasy()
    // Autoship switches disabled for now
    // setUpRedesignedCartAutoshipSwitches();

    subscribeToCartStateUpdate(handleCartStateUpdate);

    document.addEventListener("liquid-ajax-cart:request-end", handleCartRequestEnd);

    var cartContainer = document.querySelector(".welleasy-redesigned-cart");
    if (cartContainer)
    {
        var observer = new MutationObserver(handleMutationForReinit);
        observer.observe(cartContainer, { childList: true, subtree: true });
    }
}

function InitCartPageOnly( )
{
    var path;

    path = ( window.location.pathname || "" ).replace( /\/$/, "" );

    if ( path == "/cart" )
    {
        InitCartPageOnly_StripNow( );
        InitCartPageOnly_OverrideDrawer( );
    }

}

function InitCartPageOnly_StripNow( )
{
    setTimeout( InitCartPageOnly_StripNow_Async, 0 );
}

function InitCartPageOnly_StripNow_Async( )
{
    stripLiquidCartAttrFromCartPageButtons( );
}

function InitCartPageOnly_OverrideDrawer( )
{
    var originalUpdateCartDrawer;
    var sectionsParam;

    originalUpdateCartDrawer = window.updateCartDrawer;
    sectionsParam            = "cart-drawer-section,cart-products-auto-render,welleasy-new-cart-template";

    if ( originalUpdateCartDrawer )
    {
        window.updateCartDrawer = function CartPageUpdateCartDrawer( cartData )
        {
            InitCartPageOnly_HandleDrawerUpdate( originalUpdateCartDrawer, sectionsParam, cartData );
        };
    }

}

function InitCartPageOnly_HandleDrawerUpdate( originalUpdateCartDrawer, sectionsParam, cartData )
{
    var merged;
    var missingSections;

    merged          = cartData;
    missingSections = ( !merged || !merged.sections || !merged.sections[ "welleasy-new-cart-template" ] );

    if ( missingSections )
    {
        fetch( "/?sections=" + sectionsParam )
            .then( InitCartPageOnly_ParseSections )
            .then( function InitCartPageOnly_ApplyFetched( sections )
            {
                var updated;

                updated = Object.assign( { }, merged || { }, { sections: sections } );

                originalUpdateCartDrawer( updated );
                updateRedesignedCartContent( updated.cart || updated );
            })
            .catch( function InitCartPageOnly_Fallback( )
            {
                originalUpdateCartDrawer( cartData );
            });
    }
    else
    {
        originalUpdateCartDrawer( merged );
        updateRedesignedCartContent( merged.cart || merged );
    }

}

function InitCartPageOnly_ParseSections( response )
{
    return response.json( );
}

function WelleasyRedesignedCartOnDOMReady( )
{
    InitCartPageOnly( );
    initRedesignedCartOnLoad( );
}

document.addEventListener( "DOMContentLoaded", WelleasyRedesignedCartOnDOMReady );